import {Menu as MenuDto} from "@sobr/wine-menu-client/dist/api";
import React, {ReactElement} from "react";
import {MenuCard} from "./MenuCard";

export interface MenuListProps {
    menus: MenuDto[]
}

export function MenuList(props: MenuListProps): ReactElement {
    return (
        <div className="w-full pt-4 px-12 grid grid-cols-3 gap-12 items-start
                        xl:grid-cols-4 2xl:grid-cols-6">
            {props.menus.map(m => <MenuCard menu={m} key={m.id} />)}
        </div>
    )
}

